import CustomOfferAcceptedForm from './CustomOfferAcceptedForm';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';

const { Money } = sdkTypes;

const offer = {
  customOfferAmount: new Money(250000, config.currency),
  customOfferPlusVATAmount: new Money(313750, config.currency),
  customOfferVATAmount: new Money(63750, config.currency),
  customOfferTitle: 'Verkkosivujen uudistus ja SEO-optimointi',
  customOfferDescription:
    'Suunnittelen ja toteutan uuden verkkosivuston WordPressillä. Sisältää etusivun, palvelusivut ja yhteydenottolomakkeen sekä perus-SEO:n.',
  customOfferStartDate: '2026-10-01',
  customOfferDeliveryDate: '2026-11-15',
  onSubmit: values => {
    console.log('submit values:', values);
  },
};

// Invoice-billed customer looking at the offer they can accept.
export const Customer = {
  component: CustomOfferAcceptedForm,
  props: {
    formId: 'CustomOfferAcceptedForm.Customer',
    isProvider: false,
    isProOrInvoiceCustomer: true,
    ...offer,
  },
  group: 'forms',
};

// Provider view of the same offer, with the commission breakdown.
export const Provider = {
  component: CustomOfferAcceptedForm,
  props: {
    formId: 'CustomOfferAcceptedForm.Provider',
    isProvider: true,
    isProOrInvoiceCustomer: true,
    showCustomOfferFormAcceptedProvider: true,
    ...offer,
  },
  group: 'forms',
};

// Offer made before the start date field existed: the delivery date stands alone.
export const WithoutStartDate = {
  component: CustomOfferAcceptedForm,
  props: {
    formId: 'CustomOfferAcceptedForm.WithoutStartDate',
    isProvider: false,
    isProOrInvoiceCustomer: true,
    ...offer,
    customOfferStartDate: undefined,
  },
  group: 'forms',
};

// Offer made before the title field existed.
export const WithoutTitle = {
  component: CustomOfferAcceptedForm,
  props: {
    formId: 'CustomOfferAcceptedForm.WithoutTitle',
    isProvider: false,
    isProOrInvoiceCustomer: true,
    ...offer,
    customOfferTitle: undefined,
  },
  group: 'forms',
};
